import { LoadingButton } from "@mui/lab";
import { Grid, TextField, Typography, Link } from "@mui/material";
import { useState } from "react";
import styles from './PhotoDay.module.css';
import React, { MouseEvent } from 'react';

interface IProps {
    photoDayImportField: Function;
    loading: boolean;
    error: boolean;
  }

function PhotoDayImportField({ photoDayImportField, loading, error }: IProps){

    const [eventId, setEventId] = useState('');

    const clearSearchField = (event: MouseEvent) => {
        event.preventDefault();
        setEventId('');
      };
    
      const handleSubmit = (event: React.SyntheticEvent) => {
        event.preventDefault();
        setEventId('');
        photoDayImportField(eventId);
      };
    
    return (
        <form onSubmit={handleSubmit}>
          <Grid
            container
            alignItems='center'
            justifyContent='flex-start'
            spacing={2}
          >
            <Grid item sm={7} xs={12}>
              <TextField
                size='small'
                fullWidth
                value={eventId}
                onChange={(e) => setEventId(e.target.value.trim().toUpperCase())}
                placeholder='Enter Lifetouch Event Id for PhotoDay Import'
                disabled={loading}
                error={error}
                label='Enter Lifetouch Event Id for PhotoDay Import'
              />
            </Grid>
    
            <Grid item md={3} sm={4} xs={12}>
              <LoadingButton
                fullWidth
                variant='contained'
                className={styles.searchButton}
                loading={loading}
                loadingPosition='end'
                type='submit'
              >
                Import PhotoDay Job
              </LoadingButton>
            </Grid>
            <Grid item container xs={12} sm='auto'>
              <Link href={''} onClick={clearSearchField}>
                <Typography variant='subtitle2'>Reset Import</Typography>
              </Link>
            </Grid>
          </Grid>
          <p style={{ fontStyle: "italic" }}> Enter the Event ID to Upload the Underclass PhotoDay file.
               This is only for underclass events that were photographed by PhotoDay.</p>
        </form>
      );
    }

export default PhotoDayImportField;